export default {
  title: {
    id: 'hc_home_orders_section_title',
    defaultMessage: 'Manage your items',
  },
  filterAll: {
    id: 'hc_home_orders_filter_all',
    defaultMessage: 'All',
  },
  filterPurchases: {
    id: 'hc_home_orders_filter_purchases',
    defaultMessage: 'Purchases',
  },
  filterTradeIns: {
    id: 'hc_home_orders_filter_trade_ins',
    defaultMessage: 'Trade-ins',
  },
  loading: {
    id: 'spinner',
    defaultMessage: 'Loading',
  },
  datePrefixOn: {
    id: 'hc_home_order_card_date_prefix_on',
    defaultMessage: 'On: {date}',
  },
  datePrefixPaymentDueBy: {
    id: 'hc_home_order_card_date_prefix_payment_due_by',
    defaultMessage: 'Payment due by: {date}',
  },
  datePrefixEstimatedDelivery: {
    id: 'hc_home_order_card_date_prefix_estimated_delivery',
    defaultMessage: 'Estimated delivery: {date}',
  },
}
